import React from 'react';
import { Box } from '@material-ui/core';

/**
 * ContentBody Container Component
 */
const ContentBody = ({ children, padding = 16, ...props }) => (
  <Box
    component="main"
    p={`${padding}px`}
    flex={1}
    {...props}
  >
    {children}
  </Box>
);

export default ContentBody;
